import Vue from 'vue'
import Element from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import './element-variables.scss'

Vue.use(Element, { size: "mini" })
